import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../App';
import { toast } from 'react-toastify';
import MobileNav from '../Layout/MobileNav';
import InstallPrompt from '../PWA/InstallPrompt';

function UserLayout({ children, session }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    fetchProfile();
  }, [session]);

  const fetchProfile = async () => {
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', session.user.id)
        .single();

      if (error) throw error;
      setProfile(data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast.success('Logged out successfully!');
      navigate('/');
    } catch (error) {
      toast.error('Error logging out');
    }
  };

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <div className="dashboard-container">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <Link to="/" className="logo" style={{ textDecoration: 'none' }}>
            <span className="zero">ZERO</span>
            <span className="ping">PING</span>
          </Link>

          {/* Mobile Wallet Button */}
          <Link to="/dashboard/wallet" className="mobile-wallet-btn">
            💰 Wallet
          </Link>

          <div className="nav-menu">
            <Link
              to="/dashboard/matches"
              className={`nav-link ${isActive('/dashboard/matches') ? 'active' : ''}`}
            >
              🎮 Matches
            </Link>
            <Link
              to="/dashboard/results"
              className={`nav-link ${isActive('/dashboard/results') ? 'active' : ''}`}
            >
              🏆 Results
            </Link>
            <Link
              to="/dashboard/registrations"
              className={`nav-link ${isActive('/dashboard/registrations') ? 'active' : ''}`}
            >
              📋 My Games
            </Link>
            <Link
              to="/dashboard/teams"
              className={`nav-link ${isActive('/dashboard/teams') ? 'active' : ''}`}
            >
              👥 Teams
            </Link>
            <Link
              to="/dashboard/wallet"
              className={`nav-link ${isActive('/dashboard/wallet') ? 'active' : ''}`}
            >
              💰 Wallet
            </Link>
            <Link
              to="/dashboard/withdrawal"
              className={`nav-link ${isActive('/dashboard/withdrawal') ? 'active' : ''}`}
            >
              💸 Withdraw
            </Link>
            <button className="btn btn-danger" onClick={handleLogout} style={{ padding: '8px 16px' }}>
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
        {/* Welcome Banner */}
        <div style={{
          marginBottom: '30px',
          padding: '20px',
          background: 'linear-gradient(135deg, rgba(0, 240, 255, 0.1), rgba(255, 0, 255, 0.1))',
          borderRadius: '12px',
          border: '1px solid var(--border-color)'
        }}>
          <h2 style={{ fontSize: '1.8rem', marginBottom: '8px' }}>
            Welcome, {profile?.username || 'Warrior'}! 🎮
          </h2>
          <p style={{ color: 'var(--text-secondary)' }}>
            BGMI ID: <span style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>
              {profile?.bgmi_username || 'Not set'}
            </span>
          </p>
        </div>

        {/* Page Content */}
        {children}
      </div>

      {/* PWA Install Prompt */}
      <InstallPrompt />

      {/* Mobile Navigation */}
      <MobileNav currentPath={location.pathname} navigate={navigate} />
    </div>
  );
}

export default UserLayout;
